import * as _ from 'lodash';
import { TSilhouetteMarkerModel } from './silhouette-marker.types';
import pointInPolygon from 'point-in-polygon';

export const SILHOUETTE_MARKER_UTILS = {
  hasCoordinateInActiveArea: (coordinate: [number, number], silhouetteModel: TSilhouetteMarkerModel): boolean => {
    return !!silhouetteModel.areas.find((v) => v.isActive && pointInPolygon(coordinate, v.coordinateByPercent));
  },
};
